import React, { useState, useEffect } from "react";
import Breadcrumb from "../../component/breadcrumb/breadcrumb";
import { Button, Col, Form, InputGroup, Row, Dropdown } from "react-bootstrap";
import { IoFilter } from "react-icons/io5";
import { FaAngleDown, FaSearch } from "react-icons/fa";
import Mobile from "../../component/mobile/mobile";
import { Link, useParams, useNavigate } from "react-router-dom";
import hospitalImage from "../../assets/hospital.jpg";
import { CiLocationOn } from "react-icons/ci";
import { PiMedalLight } from "react-icons/pi";
import { TbBed } from "react-icons/tb";
import "./hospitals.css";
import { SurgeryHospitals } from "../../env/action";

export default function Hospitals() {
  const { surgeryId } = useParams();
  const navigate = useNavigate();
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(false);

 

  const [selectedCategories, setSelectedCategories] = useState([]);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedCategories((prev) => [...prev, value]);
    } else {
      setSelectedCategories((prev) => prev.filter((c) => c !== value));
    }
  };

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    setLoading(true);

    SurgeryHospitals(
      { surgery_id: surgeryId },
      (res) => {
        if (res?.status === 1) {
          setHospitals(res.data);
        } else {
          console.log("No hospitals found");
        }
        setLoading(false);
      }
    );
  }, [surgeryId]);

  const handleHospitalClick = (hospital_id) => {
      navigate(`/book-a-surgery/surgerydetail/${hospital_id}`, {
        state: { surgeryId }
      });
    };

  return (
    <>
      <div style={{ backgroundColor: "#F9F9F9" }}>
        <div className="container hospitaldetail pb-5">
          <Breadcrumb
            breadcrumbTitle="Hospitals"
            breadcrumbNav={[{ navText: "Home", path: "/" }]}
          />

          <div className="pt-5">
            {/* <div className="fw-bold fs-5">40+ Hospitals</div> */}


            {/* HOSPITAL LIST */}
            <div className="row mt-5">
              {hospitals.map((hospital, index) => (
                <div className="col-md-6 col-sm-12 mb-3" key={index}>
                  <div className="card position-relative h-100" style={{ width: "100%" }}>
                    <div className="row g-0">
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <img
                          src={hospitalImage}
                          className="img-fluid rounded-start w-100 h-100"
                          alt="hospital"
                          style={{ objectFit: "cover" }}
                        />
                      </div>

                      <div className="col-lg-8 col-md-12 col-sm-12">
                        <div className="card-body">
                          <h5 className="card-title fw-bolder">
                            {hospital.name}
                          </h5>

                          <div className="d-flex mt-3">
                            <PiMedalLight style={{ fontSize: "40px" }} />
                            <p className="card-text ms-2">{hospital.description}</p>
                          </div>

                          <div className="d-flex mt-2">
                            <TbBed style={{ fontSize: "25px" }} />
                            <p className="card-text ms-2">{hospital.beds}</p>
                          </div>

                          <Link to="/hospital-details-location" style={{ textDecoration: "none", color: "black" }}>
                            <div className="d-flex mt-2">
                              <CiLocationOn style={{ fontSize: "35px" }} />
                              <p className="card-text ms-2">{hospital.address}</p>
                            </div>
                          </Link>

                          <button
                            className="btn w-100 btn-primary mt-4"
                            onClick={() => handleHospitalClick(hospital.id)}
                          >
                            Book Appointment
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

      <Mobile />
    </>
  );
}
